import { fetchPartner360ProgramTypes } from 'legacy/lut/services/partner360/configuration/fetchPartner360ProgramTypes'
import { mapPartner360ProgramTypes } from 'legacy/lut/services/partner360/configuration/mappings/mapPartner360ProgramTypes'
import { IJBPOfferingsCrudParams } from 'legacy/lut/services/partner360/configuration/models'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { REQUEST_PROGRAM_TYPES } from '../constants'
import { IProgramType } from '../models/programType'
import { selectConfigurationLoadingStatus } from '../selectors/selectConfigurationLoadingStatus'

/**
 * @deprecated will be removed since we have receive it via JBPPartnerData.
 * Also it's need to remove all related stuff. (listeners, constants, crud (?), check mappers)
 */
export const requestProgramTypes = createAsyncThunk<IProgramType[], IJBPOfferingsCrudParams>(
  REQUEST_PROGRAM_TYPES,
  async (params) => {
    const response = await fetchPartner360ProgramTypes(params.partnerType, params.fYear)

    return mapPartner360ProgramTypes(response, params.programOfferings)
  },
  {
    condition({ partnerType }, { getState }) {
      if (!partnerType) {
        return false
      }

      const status = compose(selectConfigurationLoadingStatus, getState)()
      if (status === RequestStatus.PENDING) {
        return false
      }

      return
    },
  }
)
